/* eslint-disable no-unused-vars */
import { memo } from 'react';
import { Stack, Typography } from '@mui/material';
import SectionLayout from 'components/common/SectionLayout';
import { DatePicker, TimePicker, CustomTooltip, Label } from 'components';
import { useFacade } from './useFacade';
import { Question } from 'assets/icons';
import { useSignal } from '@preact/signals-react';

function SchedulerSection({ environment }) {
  const {
    onEndCalendarOpen,
    onStartCalendarOpen,
    startDateFromServer,
    minDateForStartCalendar,
    handleChangeDate,
    maxStartTime,
    minStartTime,
    minEndTime,
    handleChangeTime,
    endDateFromServer,
    disabledPicker,
    handleUpdatePicker,
  } = useFacade(environment);

  return (
    <SectionLayout
      leftSide={
        <>
          <Stack direction='row' spacing={0} width='105px'>
            <Typography variant='subtitle2' component='div'>
              Scheduler:
            </Typography>
            <CustomTooltip
              style={{ marginLeft: '4px' }}
              content={<Question />}
              text={
                <p>
                  Times are in your local time, If the <br /> campaign targets geo in another <br />
                  time zone you need to adjust the <br /> times (if you are in GMT+3 and the <br />
                  campaign targets geo in GMT+5 <br />
                  add two hours).
                </p>
              }
            />
          </Stack>
          <Label
            text='You can choose to run your campaign continuously starting today or during a specific date range. The times are based on your local time'
            variant='description'
            style={{ marginTop: '8px' }}
          />
        </>
      }
      rightSide={
        <>
          {
            <Stack direction='row' spacing={1}>
              <Stack direction='column' spacing={1}>
                <Typography variant='subtitle2' component='div'>
                  Start:
                </Typography>
                <Stack direction='row'>
                  <DatePicker
                    disabledPicker={disabledPicker}
                    styledInput={{
                      width: '185px',
                      borderRadius: '4px 0px 0px 4px',
                    }}
                    onCalendarOpen={onStartCalendarOpen}
                    fieldName='schedulerStartDate'
                    minDate={minDateForStartCalendar}
                    selectedDate={startDateFromServer}
                    handleChangeDate={handleChangeDate}
                    rightIconAction={() => {
                      handleUpdatePicker(null, 'schedulerStartDate');
                      handleUpdatePicker(null, 'schedulerEndDate');
                    }}
                  />
                  <TimePicker
                    disabledPicker={disabledPicker}
                    fieldName='schedulerStartDate'
                    handleChangeTime={handleChangeTime}
                    maxTime={maxStartTime}
                    minTime={minStartTime}
                    selectedTime={startDateFromServer}
                    styledInput={{ width: '120px', borderRadius: '0px 4px 4px 0px' }}
                  />
                </Stack>
              </Stack>
              <p style={{ marginTop: '40px' }}>&mdash;</p>
              <Stack direction='column' spacing={1}>
                <Typography variant='subtitle2' component='div'>
                  End:
                </Typography>
                <Stack direction='row'>
                  <DatePicker
                    rightIconAction={() => handleUpdatePicker(null, 'schedulerEndDate')}
                    disabledPicker={disabledPicker}
                    disabled={!startDateFromServer}
                    styledInput={{
                      width: '185px',
                      borderRadius: '4px 0px 0px 4px',
                    }}
                    onCalendarOpen={onEndCalendarOpen}
                    fieldName='schedulerEndDate'
                    minDate={
                      startDateFromServer > minDateForStartCalendar
                        ? startDateFromServer
                        : minDateForStartCalendar
                    }
                    selectedDate={endDateFromServer}
                    handleChangeDate={handleChangeDate}
                  />
                  <TimePicker
                    disabledPicker={disabledPicker}
                    fieldName='schedulerEndDate'
                    handleChangeTime={handleChangeTime}
                    maxTime={maxStartTime}
                    minTime={minEndTime}
                    selectedTime={endDateFromServer}
                    styledInput={{ width: '120px', borderRadius: '0px 4px 4px 0px' }}
                  />
                </Stack>
              </Stack>
            </Stack>
          }
        </>
      }
    />
  );
}
export default memo(SchedulerSection);
